import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about-us", label: "About Us" },
  { to: "/films", label: "Films" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 nav-glass" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link
            to="/"
            className="font-heading text-xl lg:text-2xl font-semibold tracking-tight text-[#292524]"
            data-testid="nav-logo"
          >
            VISIBLE FOUNDATION
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}-link`}
                className={`animate-underline font-body text-sm font-semibold tracking-wide transition-colors ${
                  location.pathname === link.to
                    ? "text-[#C86B53]"
                    : "text-[#57534E] hover:text-[#292524]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/donate" data-testid="nav-donate-link">
              <Button
                className="bg-[#C86B53] hover:bg-[#b55c46] text-white rounded-sm px-6 h-9 text-sm font-semibold tracking-wide"
                data-testid="nav-donate-button"
              >
                Donate
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden p-2 text-[#292524]"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#FAF9F6]/95 backdrop-blur-xl border-t border-[rgba(41,37,36,0.06)]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, '-')}-link`}
                className={`font-body text-base py-1 ${
                  location.pathname === link.to ? "text-[#C86B53]" : "text-[#57534E]"
                }`}
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/donate" onClick={() => setMobileOpen(false)}>
              <Button
                className="bg-[#C86B53] hover:bg-[#b55c46] text-white rounded-sm w-full h-10 text-sm font-semibold tracking-wide mt-2"
                data-testid="mobile-donate-button"
              >
                Donate
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
